import { render, staticRenderFns } from "./ActionChoicerDialog.vue?vue&type=template&id=4973e0dc&scoped=true&"
import script from "./ActionChoicerDialog.vue?vue&type=script&lang=js&"
export * from "./ActionChoicerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4973e0dc",
  null
  
)

export default component.exports